<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <line x1="3" y1="12" x2="21" y2="12"/>
    <polyline points="14,5 21,12 14,19"/>
  </svg>
</template>
